import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { useSeo } from "@/lib/useSeo";
import { getList } from "@/lib/api";
import { IMG } from "@/lib/images";
import { PageHeader } from "@/components/Editorial";

export default function Podcast() {
  const { data: episodes = [], isLoading } = useQuery({ queryKey: ["podcasts"], queryFn: () => getList("podcasts") });

  useSeo({
    title: "Podcast",
    description: "Le podcast de Dorothée Lancelot : épisodes autour de l'ésotérisme, de son histoire, de la médiumnité, du rêve et du deuil. Disponible sur Deezer, Spotify et YouTube.",
    path: "/podcast",
  });

  if (!isLoading && episodes.length === 0) return <Navigate to="/" replace />;

  return (
    <div>
      <PageHeader eyebrow="À écouter" title="Podcast" intro="Des épisodes pour prolonger l'exploration : histoire de l'ésotérisme, médiumnité, rêves et transmission." image={IMG.candle} />
      <section className="dl-container py-16">
        <div className="space-y-5">
            {episodes.map((ep) => (
              <div key={ep.id} className="dl-card p-6 flex flex-col md:flex-row gap-6" data-testid={`podcast-${ep.id}`}>
                {ep.image_url && <img src={ep.image_url} alt={ep.title} className="w-full md:w-40 h-40 object-cover" loading="lazy" />}
                <div className="flex-1">
                  {ep.date && <div className="dl-eyebrow" style={{ fontSize: "0.6rem" }}>{ep.date}</div>}
                  <h3 className="serif text-2xl text-[#F3E9D2] mt-1">{ep.title}</h3>
                  {ep.description && <p className="text-sm text-[#F3E9D2]/70 mt-2">{ep.description}</p>}
                  {ep.audio_url && <audio controls src={ep.audio_url} className="mt-4 w-full max-w-md" />}
                  {ep.link && <a href={ep.link} target="_blank" rel="noreferrer" className="dl-link text-sm mt-3 inline-flex items-center gap-1">Écouter sur la plateforme <ExternalLink size={12} /></a>}
                </div>
              </div>
            ))}
          </div>
      </section>
    </div>
  );
}
